// extracted by mini-css-extract-plugin
module.exports = {"card-action":"BlogCard_card-action__1HouX","card":"BlogCard_card__1m0_9","div-con":"BlogCard_div-con__1tyAy","card-media":"BlogCard_card-media__1irJf"};